export enum DiscountType {
  MULTI_PARTICIPANT = 1,
  EARLY_REGISTRATION = 2
}

export enum AmountUnitType {
  PERCENT_RATE = 1,
  FIXED_AMOUNT = 2,
  NOT_SET = 'NULL'
}

export enum TimeRangeType {
  MONTHS = 1,
  DAYS = 2,
  WEEKS = 3
}

export interface MultiParticipantRule{
  participants: number;
  amount: number;
}

export interface EarlyRegistrationRule {
  timeRangeUnit: number;
  timeRangeType: TimeRangeType;
  amount: number;
}

export type DiscountRule  = MultiParticipantRule[] | [EarlyRegistrationRule];

export interface Discount {
  id: number;
  name: string;
  discountTypeId: DiscountType;
  amountUnitType: AmountUnitType;
  appliesTo: string;
  description: string;
  rules: DiscountRule;
  isActive: boolean;
  accountId: number;
}
